import React from "react";

export const Logo = ({ className = "", showText = true, size = 68 }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="site-logo">
    <img
      src="/brand/gssc-logo.png"
      alt="Golden State Safety Certifications logo"
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className="object-contain shrink-0 drop-shadow-[0_2px_10px_rgba(0,0,0,0.5)]"
    />
    {showText && (
      <div className="leading-none hidden sm:block">
        <div className="font-head font-extrabold text-[17px] tracking-tight text-white uppercase">
          Golden State
        </div>
        <div className="font-mono-x text-[8px] tracking-[0.24em] text-amber-400 uppercase mt-1">
          Safety Certifications
        </div>
      </div>
    )}
  </div>
);
